import { render } from "./BackgroundCarrusel.vue?vue&type=template&id=5c80067d&scoped=true"
import script from "./BackgroundCarrusel.vue?vue&type=script&lang=js"
export * from "./BackgroundCarrusel.vue?vue&type=script&lang=js"

import "./BackgroundCarrusel.vue?vue&type=style&index=0&id=5c80067d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c80067d"]])

export default __exports__